import { getApiValidationErrorCode } from '@/core/utils/api-error.utils';

/** True when create/claim failed because this hash is already in the workspace. */
export function isProductHashAlreadyExistsError(err: unknown): boolean {
  return getApiValidationErrorCode(err, 'hash') === 'hashAlreadyExists';
}
